import { createMuiTheme } from '@material-ui/core/styles';
import Palette from '@opsbase/lib-palette';
import { overrides, typography } from '@opsbase/web-app/theme';
export const palette = {
    ...Palette,
    primary: Palette.HelixNotificationBold,
    secondary: Palette.GoodOldBlue,
    black: Palette.Liquorice,
    positive: Palette.Greeny,
    progress: Palette.LibertyPurple,
    error: Palette.CoralRed,
    warning: Palette.OJ,
    background: {
        default: Palette.WhiteSmoke.main,
        paper: Palette.White.main,
    },
    text: {
        primary: Palette.Liquorice.main,
        secondary: Palette.BlackCoral.main,
        disabled: Palette.GreyBlue.main,
        hint: '',
    },
    divider: Palette.GreyBlue.main,
};
Palette.primary = palette.primary;
Palette.secondary = palette.secondary;
Palette.black = palette.black;
Palette.positive = palette.positive;
Palette.progress = palette.progress;
Palette.error = palette.error;
Palette.warning = palette.warning;
export const theme = createMuiTheme({
    palette,
    typography: typography(),
    overrides: overrides(palette),
});
